import(/* webpackMode: "eager" */ "/vercel/path0/apps/stories/src/app/global-error.jsx");
